import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/oneauth')({
  component: RouteComponent,
})

function RouteComponent() {
  return <Outlet />
}
